export default "__VITE_ASSET__CqHLZ82h__"